import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/lib/auth";
import { AppShell } from "@/components/AppShell";
import { LeagueCard } from "@/components/LeagueCard";
import { toast } from "sonner";

/** Routes "/tipy" or "/tabulka" — if user has one league, redirect; else show picker. */
export const LeagueRedirect = ({ tab }: { tab: "matches" | "table" }) => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [leagues, setLeagues] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    (async () => {
      const { data: mems } = await supabase.from("league_members").select("league_id").eq("user_id", user.id);
      const ids = (mems ?? []).map(m => m.league_id);
      if (ids.length === 0) { setLeagues([]); setLoading(false); return; }
      const { data } = await supabase.from("leagues").select("*").in("id", ids);
      if (data && data.length === 1) {
        navigate(`/league/${data[0].id}?tab=${tab}`, { replace: true });
        return;
      }
      setLeagues(data ?? []);
      setLoading(false);
    })();
  }, [user, tab, navigate]);

  if (loading) return <AppShell><p className="text-muted-foreground">{t("common.loading")}</p></AppShell>;
  return (
    <AppShell title={t(tab === "matches" ? "nav.matches" : "nav.table")}>
      <h1 className="text-2xl font-bold mb-2">{t(tab === "matches" ? "nav.matches" : "nav.table")}</h1>
      <p className="text-muted-foreground text-sm mb-4">{t("league.pickLeague")}</p>
      <div className="grid gap-3 sm:grid-cols-2">
        {leagues.map(l => (
          <div key={l.id} onClick={() => navigate(`/league/${l.id}?tab=${tab}`)}>
            <LeagueCard id={l.id} name={l.name} invite_code={l.invite_code} isAdmin={l.owner_id === user?.id} logo_url={l.logo_url} />
          </div>
        ))}
      </div>
    </AppShell>
  );
};
